export const EVENTS = Object.freeze({
  SELECT: 'Signup - Select type',
  FORM_FOCUS: 'Signup - Form focus',
  INVALID_RESPONSE: 'Signup - Invalid response',
  SUBMISSION_RESPONSE: 'Signup - Email Submission result',
  ONBOARDING_STEP_COMPLETED: 'Onboarding Step Completed',
  ONBOARDING_GUIDE_COMPLETED: 'Onboarding Guide Completed',
  REDIRECT_SSO_LOGIN: 'Redirect SSO Login',
});

// Server and client events
export const SUBMISSION_RESULT = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  MISSING_FIELDS: 'missing fields',
});
